<span class="fw-normal mb-2 d-block">
  {{ 'product-variant-optie-selecteer-kleur-titel' | fromDictionary }}
  <ng-container *ngIf="hoverLabel || getLabel(activeProduct)">
    -
    <span *ngIf="!hoverLabel">{{ getLabel(activeProduct) }}</span>

    <span class="color-preview" *ngIf="hoverLabel">{{ hoverLabel }}</span>
  </ng-container>
</span>

<ul class="swatch-list">
  <li class="swatch-list__item" *ngFor="let product of products">
    <a
      [routerLink]="['../', product.handle]"
      [routerLinkActive]="'is--active'"
      [class.is--white]="
        getMetafield(product, 'kleur_filter')?.value === 'Wit' ||
        (!getMetafield(product, 'kleurcode')?.value && !getMetaImage(product, 'kleur_afbeelding'))
      "
      [style.--swatch-color]="getMetafield(product, 'kleurcode')?.value || 'white'"
      [style.--swatch-image]="getMetaImage(product, 'kleur_afbeelding')"
      (mouseenter)="hoverLabel = getLabel(product)"
      (mouseleave)="hoverLabel = undefined"
      class="swatch"
    >
      <span class="sr-only">Choose color: {{ getMetafield(product, 'kleur_filter')?.value }}</span>
      <div class="swatch__cross" *ngIf="!product.availableForSale"></div>
    </a>
  </li>
</ul>
